<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Shipping Invoice</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :addExportButton="true"
          :sendToExport="sendToExport"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_invoice_id"
              >
                <td>{{ r.invoice_number }}</td>
                <!-- <td>{{ r.branch_name }}</td> -->
                <td>{{ r.country }}</td>
                <td>{{ r.customer_id_fk }}</td>
                <td class="ws-nowrap">
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>{{ r.phone_number }}</td>
                <td><span v-if="r.handling_fee > 0" class="ship-only-label">Ship Only</span></td>
                <td>{{ r.weight }}</td>
                <td>{{ r.volume }}</td>
                <td>{{ r.handling_fee }}</td>
                <td>{{ r.shipment }}</td>
                <td>{{ r.tax }}</td>
                <td>{{ r.delivery_price }}</td>
                <td>{{ r.total_price }}</td>
                <td>{{ r.discount }}</td>
                <td>{{ r.net_price }}</td>
                <td>{{ r.note }}</td>
                <td>{{ r.created_at | moment('YYYY-MM-DD hh:mm a') }}</td>
                <td>
                  <div class="d-flex">
                    <a
                      tooltip="Invoice"
                      class="px-1"
                      @click="viewRecord(r.order_invoice_id)"
                    >
                      <i
                        class="fa fa-file-text-o"
                        style="font-size: 18px; color: #666"
                      ></i>
                    </a>

                    <a
                      v-if="$_has_perm('delete_shipping_invoice')"
                      tooltip="Delete"
                      class="px-1"
                      @click="deleteRow(r.order_invoice_id)"
                    >
                      <i
                        class="fa fa-trash error--text"
                        style="font-size: 18px"
                      ></i>
                    </a>
                  </div>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-order-invoice
      :viewOrderInvoiceModal="viewOrderInvoiceModal"
      :invoiceData="invoiceData"
      :companyData="companyData"
      @close="viewOrderInvoiceModal = false"
    />
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import axios from 'axios'
import swal from 'sweetalert'
import ViewOrderInvoice from './viewOrderInvoice.vue'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    ViewOrderInvoice
  },
  mounted() {
    this.perPageFix()
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      {
        label: 'Invoice No.',
        text: 'Invoice No.',
        value: '1',
        sortable: true,
        searchable: true,
        name: 'invoice_number'
      },
      // {
      //   label: 'Branch',
      //   text: 'Branch',
      //   value: '2',
      //   sortable: true,
      //   searchable: false,
      //   name: 'branch_name'
      // },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '2',
        sortable: true,
        searchable: false,
        name: 'country'
      },
      {
        label: 'Customer ID',
        text: 'Customer ID',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'customer_id_fk'
      },
      {
        label: 'Customer',
        text: 'Customer',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: 'Customer Note',
        text: 'Customer Note',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'customer_note'
      },
      {
        label: 'Phone',
        text: 'Phone',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'phone'
      },
      {
        label: 'Shiponly',
        text: 'Shiponly',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'shiponly'
      },
      {
        label: 'Weight',
        text: 'Weight',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'weight'
      },
      {
        label: 'Volume',
        text: 'Volume',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'volume'
      },
      {
        label: 'Handling Fee',
        text: 'Handling Fee',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'handling_fee'
      },
      {
        label: 'Shipment',
        text: 'Shipment',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'shipment'
      },
      {
        label: 'Tax',
        text: 'Tax',
        value: '12',
        sortable: true,
        searchable: true,
        name: 'tax'
      },
      {
        label: 'Delivery price',
        text: 'Delivery price',
        value: '13',
        sortable: true,
        searchable: true,
        name: 'delivery_price'
      },
      {
        label: 'Total price',
        text: 'Total price',
        value: '14',
        sortable: true,
        searchable: true,
        name: 'total_price'
      },
      {
        label: 'Discount',
        text: 'Discount',
        value: '15',
        sortable: true,
        searchable: true,
        name: 'discount'
      },
      {
        label: 'Net price',
        text: 'Net price',
        value: '16',
        sortable: true,
        searchable: true,
        name: 'net_price'
      },
      {
        label: 'Note',
        text: 'Note',
        value: '17',
        sortable: true,
        searchable: true,
        name: 'note'
      },
      {
        label: 'Created At',
        text: 'Created At',
        value: '18',
        sortable: true,
        searchable: true,
        name: 'created_at'
      }
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/order_invoice',
      alertValue: false,
      btnsave: true,
      viewOrderInvoiceModal: false,
      invoiceData: {
        customer: {},
        orders: []
      },
      companyData: {},
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'order_invoice_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_invoices.updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    sendToExport() {
      let searchValue = this.tableData.search !== '' ? this.tableData.search : '0'
      let column = this.tableData.column !== '' ? this.tableData.column : '0'
      let sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0'
      let searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0'
      let searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0'
      let fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0'
      let toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0'

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      // let fullHostName = 'http://shipzone.test'

      window.location.replace(
        fullHostName +
        '/api/order_invoice/export?searchValue=' +
        searchValue +
        '&column=' +
        column +
        '&sortDir=' +
        sortDir +
        '&searchedOneCol=' +
        searchedOneCol +
        '&searchedOneVal=' +
        searchedOneVal +
        '&from_date=' +
        fromDate +
        '&to_date=' +
        toDate
      )
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getCompanyData(token) {
      axios
        .get('api/company_info', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.companyData = response.data.data
        })
    },

    viewRecord(id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)

      axios
        .get(`api/order_invoice/${id}`, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((res) => {
          this.viewOrderInvoiceModal = true
          this.invoiceData = res.data
        })
    },

    deleteRow(id) {
      swal({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(`api/order_invoice/${id}`, { headers: { Authorization: 'Bearer ' + token } })
            .then(() => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(() => { })
        }
      })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderInvoice/orderInvoices.vue